import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  buttonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 50,
  },
  buttonText: {
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
    marginHorizontal: 8,
    paddingHorizontal: 10,
    margin: 0,
    fontSize: 14,
  },
  buttonOuter: {
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
    flexGrow: 0,
    paddingHorizontal: 1,
    marginHorizontal: 5,
    minWidth: 1,
  },
  noFlexGrow: {
    flexShrink: 0,
    flexGrow: 0,
    flexBasis: 'auto',
  },
});
